import CheckboxList from './CheckboxList';
import Content from './Content';
import Header from './Header';
import LandingPage from './LandingPage';
import Chart from './Chart';

const Skeleton = {
  CheckboxList,
  Content,
  Header,
  LandingPage,
  Chart,
};

export default Skeleton;
